import {MixForm} from '.'

export const isMaterialVariationDirty = (
  fieldValue: MixForm['materialVariations'],
  defaultValue?: MixForm['materialVariations']
) => {
  return (
    defaultValue?.slump?.value !== fieldValue?.slump?.value ||
    defaultValue?.setControl?.value !== fieldValue?.setControl?.value
  )
}
